import { Button, Card, Row, Col, Form, Input, Modal, message } from "antd";
import React, { useState } from "react";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import "./login.scss";
import login_logo from "../../assets/logo.svg";
import google from "../../assets/gmail.svg";
import or from "../../assets/or.svg";
import userService from "../../services/userService";
import { CloseCircleFilled } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { setUserData } from "../../Components/Redux/actions";

const ROOT = `login_module`;

export default function Login() {
  const location = useLocation();
  let url = location.search.substring(location.search.indexOf("?") + 1);
  const yturl = url.startsWith("https://www.youtube.com");
  const navigate = useNavigate();
  const [viewModal, setViewModal] = useState(false);
  const [form] = Form.useForm();
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();

  const modalShow = () => {
    setViewModal(true);
  };

  const modalHide = () => {
    setViewModal(false);
  };
  const [handleSubmitBtn, setHandleSubmitBtn] = useState(false);
  const [handleResetPasswordBtn, setHandleResetPasswordBtn] = useState(false);

  const login = async (values) => {
    let formData = values;
    // console.log(formData)
    if (formData.email && formData.password) {
      try {
        setHandleSubmitBtn(true);
        const response = await userService.loginUser(formData);
        // console.log('verify', verifyUser)
        if (response.error) {
          console.log("error in login", response);
          message.destroy();
          message.error(
            response?.error?.message || "Something went wrong while logging in"
          );
          navigate("/login");
        } else {
          message.destroy();
          message.success(response?.message || "Logged in successfully");
          let user = JSON.stringify(response?.data);
          dispatch(setUserData(user));
          localStorage.removeItem("user-signup");
          yturl ? navigate(`/dashboard?${url}`) : navigate("/dashboard");
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      } catch (error) {
        console.log("error in login", error);
        // message.destroy()
        // message.error('Link Invalid or Expired')
        navigate("/login");
      }
      setHandleSubmitBtn(false);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const forgotPassword = async (values) => {
    let formData = values;
    // console.log(formData)
    // return
    if (formData.email) {
      try {
        setHandleResetPasswordBtn(true);
        const response = await userService.resetPasswordRequest(formData);
        // console.log('verify', verifyUser)
        if (response.error) {
          message.destroy();
          message.error(
            response?.error?.message ||
              "Something went worng in resetting password"
          );
          navigate("/login");
        } else {
          message.destroy();
          message.success(
            response?.message || "Reset password request sent successfully"
          );
        }
        modalHide();
      } catch (error) {
        // message.destroy()
        // message.error(error?.response?.data?.message || 'Link Invalid or Expired')
        navigate("/login");
        modalHide();
      }
    }
    setHandleResetPasswordBtn(false);
    form.resetFields();
  };
  return (
    <>
      <Modal
        open={showModal}
        // title="Set your password."
        onCancel={() => setShowModal(false)}
        closeIcon={<CloseCircleFilled style={{ fontSize: "20px" }} />}
        footer={null}
        centered
      >
        <div className="px-3 py-4 d-flex flex-column align-items-center text-center">
          <p
            className="mt-3"
            style={{ fontFamily: '"Nunito", sans-serif', fontSize: "15px" }}
          >
            Our email services are currently down. <br></br>
            We apologise for the the inconvenience. <br></br>
            <br></br>
            Try again after some time.
          </p>
        </div>
      </Modal>
      <Modal
        className={`${ROOT}__modal_ui`}
        open={viewModal}
        title=""
        onOk={() => form.submit()}
        okText="Submit"
        onCancel={() => {
          form.resetFields();
          modalHide();
        }}
        okButtonProps={{ disabled: handleResetPasswordBtn }}
      >
        <div className="mb-3 mt-4">
          <h5>
            A reset password link will be sent to your email. Click on the link
            sent, to reset your password.
          </h5>
        </div>
        <Form
          form={form}
          preserve={false}
          name="forgot-password"
          layout="vertical"
          className="login-form"
          initialValues={{
            email: "",
          }}
          onFinish={forgotPassword}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            name="email"
            rules={[
              {
                type: "email",
                message: "The input is not valid E-mail!",
              },
              {
                required: true,
                message: "Please input your email!",
              },
            ]}
            label="Enter Email"
          >
            <Input placeholder="example@gmail.com" size="large" />
          </Form.Item>
        </Form>
      </Modal>
      <div className={`${ROOT}__auth`} align="middle">
        <Row style={{ height: "100vh" }}>
          <Col lg={8} md={22} xs={22} className="m-auto">
            <Card>
              <div className="text-center">
                <img alt="user" src={login_logo} />
              </div>
              <h5 className="text-center">Log In</h5>
              {/* <div className="or text-center">
                <img
                  alt="user"
                  src={or}
                />
              </div> */}
              <Form
                name="normal_login"
                layout="vertical"
                className="login-form"
                initialValues={{
                  email: "",
                  password: "",
                }}
                onFinish={login}
                onFinishFailed={onFinishFailed}
              >
                <Form.Item
                  name="email"
                  rules={[
                    {
                      type: "email",
                      message: "The input is not valid E-mail!",
                    },
                    {
                      required: true,
                      message: "Please input your email!",
                    },
                  ]}
                  label="Enter Email"
                >
                  <Input placeholder="john@doe.com" size="large" />
                </Form.Item>
                <Form.Item
                  className="mb-4"
                  name="password"
                  label="Enter Password"
                  rules={[
                    {
                      required: true,
                      message: "Please input your password!",
                    },
                  ]}
                >
                  <Input.Password placeholder="Enter Password" size="large" />
                </Form.Item>
                <Form.Item className="mb-0">
                  <p className="text-end text-dark">
                    {" "}
                    <a
                      className="login-form-forgot"
                      onClick={() => modalShow()}
                    >
                      Forgot password
                    </a>
                  </p>
                </Form.Item>
                <Form.Item className="mb-0">
                  <Button
                    block
                    size="large"
                    type="primary"
                    htmlType="submit"
                    className="login-form-button"
                    disabled={handleSubmitBtn}
                  >
                    Log in
                  </Button>
                </Form.Item>
                <Form.Item className="mb-0">
                  <p className="text-left bottom_link mt-2">
                    {" "}
                    Don’t have an account?{" "}
                    <Link
                      as={NavLink}
                      to={yturl ? `/signup?${url}` : "/signup"}
                    >
                      Create One!
                    </Link>
                  </p>
                </Form.Item>
              </Form>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}
